// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SearchBrokerageAgentTeam - Create Order search UI (brokerage / agent / team member) */
.search-bat-wrap * {
  box-sizing: border-box;
}
.search-bat-wrap {
  font-family: Roboto, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  /* background: #f4f6fb; */
  /* padding: 40px 20px; */
  margin: 0;
}
/* .search-bat-wrap .search-bat-inner {
  max-width: 640px;
  margin: 0 auto;
} */
.search-bat-wrap .search-bat-title {
  font-size: 22px;
  font-weight: 700;
  color: #0f1726;
  margin-bottom: 4px;
}
.search-bat-wrap .search-bat-sub {
  font-size: 13px;
  color: #7b8baa;
  margin-bottom: 24px;
}
/* .search-bat-wrap .search-bat-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
} */
.search-bat-wrap .search-bat-card-head {
  padding: 0px 22px;
  border-bottom: 1px solid #f0f2f7;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  font-size: 14px;
  color: #0f1726;
}
.search-bat-wrap .search-bat-badge,
.search-bat-badge {
  font-size: 11px;
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 20px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  font-family: 'Roboto', sans-serif;
  /* font-size: 11px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 20px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  line-height: 1;
  font-family: Roboto, sans-serif; */
}

.search-bat-wrap .search-bat-grp-label {
  padding: 8px 14px 4px;
  font-size: 12px;
  font-weight: 600;
  color: #111827;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  font-family: 'Roboto', sans-serif;
}
.search-bat-wrap .search-bat-badge-b,
.search-bat-badge-b {
  background: #DBEAFE;
  color: #1D4ED8;
  line-height: none;
}
.search-bat-wrap .search-bat-badge-m,
.search-bat-badge-m {
  background: #FEF3C7;
  color: #B45309;
}
.search-bat-wrap .search-bat-badge-a,
.search-bat-badge-a {
  background: #D1FAE5;
  color: #065F46;
}
.search-bat-wrap .search-bat-badge-ba,
.search-bat-badge-ba {
  /* background: #e0f2fe;
  color: #0284c7; */
  background: #D1FAE5;
  color: #065F46;
}
.search-bat-wrap .search-bat-badge-o,
.search-bat-badge-o {
  background: #EDE9FE;
  color: #5B21B6;
}
/* .search-bat-wrap .search-bat-body {
  padding: 24px 22px 28px;
} */
.search-bat-wrap .search-bat-label {
  /* font-size: 14px;
  font-weight: 500;
  color: #101828;
  display: block;
  margin-bottom: 7px;
  font-family: Roboto, sans-serif; */
  font-size: 13px;
    font-weight: 500;
    color: #374151;
    display: block;
    margin-bottom: 7px;
    font-family: 'Roboto', sans-serif;
}
.search-bat-wrap .search-bat-req {
  color: #ef4444;
}
.search-bat-wrap .search-bat-search-wrap {
  position: relative;
  margin-bottom: 22px;
  margin-top: 22px;
}

/* Create Project / embedded: no nested card; parent supplies the field label */
.search-bat-wrap.search-bat--project-create .search-bat-embedded {
  background: transparent;
  border: none;
  box-shadow: none;
  border-radius: 0;
}

.search-bat-wrap.search-bat--project-create .search-bat-body--embedded {
  padding: 0;
}

.search-bat-wrap.search-bat--project-create .search-bat-search-wrap {
  margin-bottom: 12px;
}

.search-bat-wrap .search-bat-search-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px 0 12px;
  flex-shrink: 0;
}

.search-bat-wrap.search-bat--project-create .search-bat-search-box {
  height: 40px;
  border-radius: 8px;
  border-width: 1px;
  border-color: #d1d5db;
}

.search-bat-wrap.search-bat--project-create .search-bat-search-input {
  padding: 9px 8px;
  font-size: 14px;
}
.search-bat-wrap .search-bat-search-box {
  display: flex;
  align-items: center;
  border: 1.5px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
}

/* Signage pages: keep the search input from spanning full width */
.signage-search-half .search-bat-search-box {
  /* Let the wrapper control the width so the dropdown + input match */
  width: 100% !important;
  margin-right: auto !important;
}

/* Signage pages: dropdown should match input width (positioned against search-wrap) */
.signage-search-half .search-bat-search-wrap {
  width: 50% !important;
  margin-right: auto !important;
}

.signage-search-half .search-bat-dropdown {
  left: 0 !important;
  right: auto !important;
  width: 100% !important;
}
.search-bat-wrap .search-bat-search-box:focus-within {
  border-color: #3b6fe8;
  box-shadow: 0 0 0 3px rgba(59, 111, 232, 0.1);
}
.search-bat-wrap.search-bat--readonly .search-bat-search-box {
  background: #f8fafc;
  cursor: not-allowed;
}
.search-bat-wrap.search-bat--readonly .search-bat-search-box:focus-within {
  border-color: #d1d5db;
  box-shadow: none;
}
.search-bat-wrap .search-bat-search-input {
  flex: 1 1;
  border: none;
  outline: none;
  /* font-size: 14px;
  color: #0f1726; */
  padding: 11px 8px;
  font-family: inherit;
  background: transparent;
      font-size: 0.875rem;
    color: #111827;
    letter-spacing: -.025em;
    font-family: Roboto, sans-serif;
    font-weight: 450 !important;
}
/* Hide browser-native clear/cancel icon for type="search"
   so only our custom clear button is visible. */
.search-bat-wrap .search-bat-search-input::-webkit-search-cancel-button,
.search-bat-wrap .search-bat-search-input::-webkit-search-decoration {
  appearance: none;
  display: none;
}
.search-bat-wrap .search-bat-search-input::-ms-clear,
.search-bat-wrap .search-bat-search-input::-ms-reveal {
  display: none;
  width: 0;
  height: 0;
}
.search-bat-wrap.search-bat--readonly .search-bat-search-input {
  cursor: not-allowed;
}
.search-bat-wrap .search-bat-clear-btn {
  background: none;
  border: none;
  cursor: pointer;
  /* padding: 0 10px; */
  color: #9ca3af;
  font-size: 20px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.search-bat-wrap .search-bat-hints {
  display: flex;
  gap: 8px;
  margin-top: 10px;
  flex-wrap: wrap;
}
.search-bat-wrap .search-bat-hint {
  background: none;
  border: 1px solid #e5e9f2;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 12px;
  color: #7b8baa;
  cursor: pointer;
  font-family: inherit;
}
.search-bat-wrap .search-bat-hint:hover {
  border-color: #3b6fe8;
  color: #3b6fe8;
}
.search-bat-wrap .search-bat-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.16);
  border: 1px solid #e5e9f2;
  z-index: 999;
  max-height: 320px;
  overflow-y: auto;
  overflow-x: hidden;
}
/* .search-bat-wrap .search-bat-grp-label {
  padding: 8px 14px 4px;
  font-size: 12px;
  font-weight: 700;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  font-family: Roboto, sans-serif;
} */
.search-bat-wrap .search-bat-drop-row {
  display: flex;
  align-items: center;
  gap: 35px;
  padding: 20px 25px;
  cursor: pointer;
}
.search-bat-wrap .search-bat-drop-row:hover {
  background: #f8f9fd;
}
.search-bat-wrap .search-bat-drop-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
}
.search-bat-wrap .search-bat-drop-name {
  font-weight: 500;
  font-size: 15px;
  color: #0f1726;
  letter-spacing: 0.03em;
  font-family: Roboto, sans-serif;
}
.search-bat-wrap .search-bat-drop-meta {
  font-size: 14px;
  color: #111827;
  font-weight: 500;
  font-family: Roboto, sans-serif;
}
.search-bat-wrap .search-bat-drop-email {
  font-size: 14px;
  color: #111827;
  font-weight: 500;
  font-family: Roboto, sans-serif;
  margin-top: 2px;
  word-break: break-all;
}
.search-bat-wrap .search-bat-drop-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex: 1 1;
}
.search-bat-wrap .search-bat-drop-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.search-bat-wrap .search-bat-drop-img {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  object-fit: contain;
}
.search-bat-wrap .search-bat-brok-card {
  background: #f8f9fd;
  border-radius: 10px;
  padding: 16px;
  margin-top: 20px;
  border: 1px solid #e5e9f2;
}
.search-bat-wrap .search-bat-brok-top {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}
.search-bat-wrap .search-bat-grid2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
.search-bat-wrap .search-bat-select,
.search-bat-wrap .search-bat-input {
  width: 100%;
  padding: 9px 11px;
  border-radius: 8px;
  border: 1.5px solid #d1d5db;
  font-size: 13px;
  color: #101828;
  background: #fff;
  outline: none;
  font-family: Roboto, sans-serif;
}
.search-bat-wrap .search-bat-select:focus,
.search-bat-wrap .search-bat-input:focus {
  border-color: #3b6fe8;
}
.search-bat-wrap .search-bat-input:disabled {
  background: #f8fafc;
  color: #64748b;
  cursor: not-allowed;
}
.serach-tittle{
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  display: block;
  margin-bottom: 7px;
  font-family: 'Roboto', sans-serif;
}

/* Select2 (react-select) for Office and Team Member */
.search-bat-wrap .search-bat-select2__control {
  min-height: 38px !important;
  border-radius: 8px !important;
  border: 1.5px solid #d1d5db !important;
  font-size: 13px !important;
  color: #111;
  background: #fff;
  outline: none;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
}
.search-bat-wrap .search-bat-select2__control--is-focused {
  border-color: #3b6fe8 !important;
  box-shadow: 0 0 0 1px #3b6fe8 !important;
}
.search-bat-wrap .search-bat-select2__control:hover {
  border-color: #d1d5db !important;
}
.search-bat-wrap .search-bat-select2__control--is-disabled {
  cursor: not-allowed !important;
  background: #f8fafc !important;
}
.search-bat-wrap .search-bat-select2__control--is-disabled * {
  cursor: not-allowed !important;
}
.search-bat-wrap .search-bat-select2__menu {
  z-index: 20;
}
.search-bat-wrap .search-bat-select2__menu-list {
  max-height: 240px;
}
.search-bat-wrap .search-bat-select2__option--is-focused {
  background: #f4f6fb;
}
.search-bat-wrap .search-bat-select2__option--is-selected {
  background: #eef3ff;
  color: #1e3a8a;
}
.search-bat-wrap .search-bat-select2__input-container,
.search-bat-wrap .search-bat-select2__single-value {
  font-size: 13px;
  color: #111;
}

.search-bat-wrap .search-bat-divider {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 20px 0 14px;
}
.search-bat-wrap .search-bat-divider-line {
  height: 1px;
  flex: 1 1;
  background: #e5e9f2;
}
.search-bat-wrap .search-bat-divider-text {
  /* font-size: 11px;
  font-weight: 500;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  white-space: nowrap;
  font-family: "Roboto", sans-serif; */
  font-size: 11px;
  font-weight: 500;
  color: #9CA3AF;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  white-space: nowrap;
  font-family: 'Roboto', sans-serif;
}
.search-bat-wrap .search-bat-btn-row {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 22px;
}
.search-bat-wrap .search-bat-btn-reset {
  padding: 10px 18px;
  border-radius: 8px;
  border: 1.5px solid #d1d5db;
  background: #fff;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
}
.search-bat-wrap .search-bat-btn-go {
  padding: 10px 22px;
  border-radius: 8px;
  border: none;
  background: linear-gradient(135deg, #f0a030, #e8880a);
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
  box-shadow: 0 2px 12px rgba(240, 160, 48, 0.35);
}
.search-bat-wrap .search-bat-btn-go:disabled {
  background: #e5e9f2;
  color: #9ca3af;
  box-shadow: none;
  cursor: not-allowed;
}
.search-bat-wrap .search-bat-hidden {
  display: none !important;
}

/* --------- Exact sample selectors (Search.html) --------- */
.divider {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 20px 0 14px;
}
.divider-line {
  height: 1px;
  flex: 1 1;
  background: #E5E9F2;
}
.divider-text {
  font-size: 11px;
  font-weight: 500;
  color: #9CA3AF;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  white-space: nowrap;
  font-family: "Roboto", sans-serif;
}
.btn-row {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 22px;
}
.btn-reset {
  padding: 10px 18px;
  border-radius: 8px;
  border: 1.5px solid #D1D5DB;
  background: #fff;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
}
.btn-go {
  padding: 10px 22px;
  border-radius: 8px;
  border: none;
  background: linear-gradient(135deg,#F0A030,#E8880A);
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
  box-shadow: 0 2px 12px rgba(240,160,48,0.35);
}
.btn-go:disabled {
  background: #E5E9F2;
  color: #9CA3AF;
  box-shadow: none;
  cursor: not-allowed;
}
.hidden {
  display: none !important;
}

/* ---------- Mobile responsive tweaks & card-style layout ---------- */
@media (max-width: 768px) {
  .search-bat-wrap .search-bat-search-box {
    height: 44px;
  }

  .search-bat-wrap .search-bat-search-input {
    padding-top: 0;
    padding-bottom: 0;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .search-bat-wrap .search-bat-clear-btn {
    height: 100%;
  }
  /* .search-bat-wrap .search-bat-body {
    padding: 16px 12px 20px;
  } */

  .search-bat-wrap .search-bat-search-box {
    border-radius: 12px;
  }

  /* On mobile, use full width for better tap targets */
  .signage-search-half .search-bat-search-box {
    width: 100% !important;
  }

  .signage-search-half .search-bat-search-wrap {
    width: 100% !important;
  }

  .signage-search-half .search-bat-dropdown {
    right: 0 !important;
    width: auto !important;
  }

  .search-bat-wrap .search-bat-dropdown {
    left: -4px;
    right: -4px;
    max-height: 60vh;
  }

  /* Make each result more like a card on mobile */
  .search-bat-wrap .search-bat-drop-row {
    flex-direction: column;
    align-items: stretch;
    padding: 12px 14px;
    margin: 6px 10px;
    gap: 10px;
    border-radius: 16px;
    border: 1px solid #e5e9f2;
  }

  .search-bat-wrap .search-bat-drop-icon {
    width: 72px;
    height: 72px;
    margin: 0 auto;
  }

  .search-bat-wrap .search-bat-drop-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .search-bat-wrap .search-bat-drop-text {
    align-items: flex-start;
  }

  .search-bat-wrap .search-bat-drop-name {
    font-size: 13px;
  }

  .search-bat-wrap .search-bat-drop-meta {
    font-size: 11px;
  }

  .search-bat-wrap .search-bat-drop-email {
    font-size: 11px;
  }

  /* Stack office / team member selects and contact fields */
  .search-bat-wrap .search-bat-grid2 {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .search-bat-wrap .search-bat-brok-card {
    padding: 14px;
    margin-top: 16px;
  }

  .search-bat-wrap .search-bat-brok-top {
    align-items: flex-start;
  }
}

.search-bat-field-error {
  margin-top: 4px;
  font-size: 12px;
  color: #dc3545;
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchBrokerageAgentTeam.css"],"names":[],"mappings":"AAAA,wFAAwF;AACxF;EACE,sBAAsB;AACxB;AACA;EACE;cACY;EACZ,yBAAyB;EACzB,wBAAwB;EACxB,SAAS;AACX;AACA;;;GAGG;AACH;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;;;;GAIG;AACH;EACE,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,iCAAiC;EACjC;;;;;;;oCAOkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,iCAAiC;AACnC;AACA;;EAEE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE;mBACiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;;GAEG;AACH;EACE;;;;;oCAKkC;EAClC,eAAe;IACb,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,iCAAiC;AACrC;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,+EAA+E;AAC/E;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kEAAkE;AAClE;EACE,oEAAoE;EACpE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA,sFAAsF;AACtF;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb;mBACiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;MACnB,mBAAmB;IACrB,cAAc;IACd,uBAAuB;IACvB,+BAA+B;IAC/B,2BAA2B;AAC/B;AACA;gDACgD;AAChD;;EAGE,gBAAgB;EAChB,aAAa;AACf;AACA;;EAEE,aAAa;EACb,QAAQ;EACR,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;;;;;GAQG;AACH;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,SAAO;AACT;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;;EAEE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,+BAA+B;AACjC;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA,sDAAsD;AACtD;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,sCAAsC;EACtC,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,SAAO;EACP,mBAAmB;AACrB;AACA;EACE;;;;;;sCAMoC;EACpC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iCAAiC;EACjC,+CAA+C;AACjD;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,SAAO;EACP,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iCAAiC;EACjC,4CAA4C;AAC9C;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;;AAEA,uEAAuE;AACvE;EACE;IACE,YAAY;EACd;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;EACA;;KAEG;;EAEH;IACE,mBAAmB;EACrB;;EAEA,qDAAqD;EACrD;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;EAClB;;EAEA,gDAAgD;EAChD;IACE,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,0DAA0D;EAC1D;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* SearchBrokerageAgentTeam - Create Order search UI (brokerage / agent / team member) */\n.search-bat-wrap * {\n  box-sizing: border-box;\n}\n.search-bat-wrap {\n  font-family: Roboto, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    sans-serif;\n  /* background: #f4f6fb; */\n  /* padding: 40px 20px; */\n  margin: 0;\n}\n/* .search-bat-wrap .search-bat-inner {\n  max-width: 640px;\n  margin: 0 auto;\n} */\n.search-bat-wrap .search-bat-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #0f1726;\n  margin-bottom: 4px;\n}\n.search-bat-wrap .search-bat-sub {\n  font-size: 13px;\n  color: #7b8baa;\n  margin-bottom: 24px;\n}\n/* .search-bat-wrap .search-bat-card {\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);\n} */\n.search-bat-wrap .search-bat-card-head {\n  padding: 0px 22px;\n  border-bottom: 1px solid #f0f2f7;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 600;\n  font-size: 14px;\n  color: #0f1726;\n}\n.search-bat-wrap .search-bat-badge,\n.search-bat-badge {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 5px 10px;\n  border-radius: 20px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  font-family: 'Roboto', sans-serif;\n  /* font-size: 11px;\n  font-weight: 700;\n  padding: 4px 10px;\n  border-radius: 20px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  line-height: 1;\n  font-family: Roboto, sans-serif; */\n}\n\n.search-bat-wrap .search-bat-grp-label {\n  padding: 8px 14px 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #111827;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  font-family: 'Roboto', sans-serif;\n}\n.search-bat-wrap .search-bat-badge-b,\n.search-bat-badge-b {\n  background: #DBEAFE;\n  color: #1D4ED8;\n  line-height: none;\n}\n.search-bat-wrap .search-bat-badge-m,\n.search-bat-badge-m {\n  background: #FEF3C7;\n  color: #B45309;\n}\n.search-bat-wrap .search-bat-badge-a,\n.search-bat-badge-a {\n  background: #D1FAE5;\n  color: #065F46;\n}\n.search-bat-wrap .search-bat-badge-ba,\n.search-bat-badge-ba {\n  /* background: #e0f2fe;\n  color: #0284c7; */\n  background: #D1FAE5;\n  color: #065F46;\n}\n.search-bat-wrap .search-bat-badge-o,\n.search-bat-badge-o {\n  background: #EDE9FE;\n  color: #5B21B6;\n}\n/* .search-bat-wrap .search-bat-body {\n  padding: 24px 22px 28px;\n} */\n.search-bat-wrap .search-bat-label {\n  /* font-size: 14px;\n  font-weight: 500;\n  color: #101828;\n  display: block;\n  margin-bottom: 7px;\n  font-family: Roboto, sans-serif; */\n  font-size: 13px;\n    font-weight: 500;\n    color: #374151;\n    display: block;\n    margin-bottom: 7px;\n    font-family: 'Roboto', sans-serif;\n}\n.search-bat-wrap .search-bat-req {\n  color: #ef4444;\n}\n.search-bat-wrap .search-bat-search-wrap {\n  position: relative;\n  margin-bottom: 22px;\n  margin-top: 22px;\n}\n\n/* Create Project / embedded: no nested card; parent supplies the field label */\n.search-bat-wrap.search-bat--project-create .search-bat-embedded {\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  border-radius: 0;\n}\n\n.search-bat-wrap.search-bat--project-create .search-bat-body--embedded {\n  padding: 0;\n}\n\n.search-bat-wrap.search-bat--project-create .search-bat-search-wrap {\n  margin-bottom: 12px;\n}\n\n.search-bat-wrap .search-bat-search-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 10px 0 12px;\n  flex-shrink: 0;\n}\n\n.search-bat-wrap.search-bat--project-create .search-bat-search-box {\n  height: 40px;\n  border-radius: 8px;\n  border-width: 1px;\n  border-color: #d1d5db;\n}\n\n.search-bat-wrap.search-bat--project-create .search-bat-search-input {\n  padding: 9px 8px;\n  font-size: 14px;\n}\n.search-bat-wrap .search-bat-search-box {\n  display: flex;\n  align-items: center;\n  border: 1.5px solid #d1d5db;\n  border-radius: 10px;\n  background: #fff;\n}\n\n/* Signage pages: keep the search input from spanning full width */\n.signage-search-half .search-bat-search-box {\n  /* Let the wrapper control the width so the dropdown + input match */\n  width: 100% !important;\n  margin-right: auto !important;\n}\n\n/* Signage pages: dropdown should match input width (positioned against search-wrap) */\n.signage-search-half .search-bat-search-wrap {\n  width: 50% !important;\n  margin-right: auto !important;\n}\n\n.signage-search-half .search-bat-dropdown {\n  left: 0 !important;\n  right: auto !important;\n  width: 100% !important;\n}\n.search-bat-wrap .search-bat-search-box:focus-within {\n  border-color: #3b6fe8;\n  box-shadow: 0 0 0 3px rgba(59, 111, 232, 0.1);\n}\n.search-bat-wrap.search-bat--readonly .search-bat-search-box {\n  background: #f8fafc;\n  cursor: not-allowed;\n}\n.search-bat-wrap.search-bat--readonly .search-bat-search-box:focus-within {\n  border-color: #d1d5db;\n  box-shadow: none;\n}\n.search-bat-wrap .search-bat-search-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  /* font-size: 14px;\n  color: #0f1726; */\n  padding: 11px 8px;\n  font-family: inherit;\n  background: transparent;\n      font-size: 0.875rem;\n    color: #111827;\n    letter-spacing: -.025em;\n    font-family: Roboto, sans-serif;\n    font-weight: 450 !important;\n}\n/* Hide browser-native clear/cancel icon for type=\"search\"\n   so only our custom clear button is visible. */\n.search-bat-wrap .search-bat-search-input::-webkit-search-cancel-button,\n.search-bat-wrap .search-bat-search-input::-webkit-search-decoration {\n  -webkit-appearance: none;\n  appearance: none;\n  display: none;\n}\n.search-bat-wrap .search-bat-search-input::-ms-clear,\n.search-bat-wrap .search-bat-search-input::-ms-reveal {\n  display: none;\n  width: 0;\n  height: 0;\n}\n.search-bat-wrap.search-bat--readonly .search-bat-search-input {\n  cursor: not-allowed;\n}\n.search-bat-wrap .search-bat-clear-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  /* padding: 0 10px; */\n  color: #9ca3af;\n  font-size: 20px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.search-bat-wrap .search-bat-hints {\n  display: flex;\n  gap: 8px;\n  margin-top: 10px;\n  flex-wrap: wrap;\n}\n.search-bat-wrap .search-bat-hint {\n  background: none;\n  border: 1px solid #e5e9f2;\n  border-radius: 20px;\n  padding: 4px 12px;\n  font-size: 12px;\n  color: #7b8baa;\n  cursor: pointer;\n  font-family: inherit;\n}\n.search-bat-wrap .search-bat-hint:hover {\n  border-color: #3b6fe8;\n  color: #3b6fe8;\n}\n.search-bat-wrap .search-bat-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.16);\n  border: 1px solid #e5e9f2;\n  z-index: 999;\n  max-height: 320px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n/* .search-bat-wrap .search-bat-grp-label {\n  padding: 8px 14px 4px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  font-family: Roboto, sans-serif;\n} */\n.search-bat-wrap .search-bat-drop-row {\n  display: flex;\n  align-items: center;\n  gap: 35px;\n  padding: 20px 25px;\n  cursor: pointer;\n}\n.search-bat-wrap .search-bat-drop-row:hover {\n  background: #f8f9fd;\n}\n.search-bat-wrap .search-bat-drop-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  flex-shrink: 0;\n}\n.search-bat-wrap .search-bat-drop-name {\n  font-weight: 500;\n  font-size: 15px;\n  color: #0f1726;\n  letter-spacing: 0.03em;\n  font-family: Roboto, sans-serif;\n}\n.search-bat-wrap .search-bat-drop-meta {\n  font-size: 14px;\n  color: #111827;\n  font-weight: 500;\n  font-family: Roboto, sans-serif;\n}\n.search-bat-wrap .search-bat-drop-email {\n  font-size: 14px;\n  color: #111827;\n  font-weight: 500;\n  font-family: Roboto, sans-serif;\n  margin-top: 2px;\n  word-break: break-all;\n}\n.search-bat-wrap .search-bat-drop-main {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex: 1;\n}\n.search-bat-wrap .search-bat-drop-text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n.search-bat-wrap .search-bat-drop-img {\n  width: 50px;\n  height: 50px;\n  border-radius: 10px;\n  object-fit: contain;\n}\n.search-bat-wrap .search-bat-brok-card {\n  background: #f8f9fd;\n  border-radius: 10px;\n  padding: 16px;\n  margin-top: 20px;\n  border: 1px solid #e5e9f2;\n}\n.search-bat-wrap .search-bat-brok-top {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n.search-bat-wrap .search-bat-grid2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n.search-bat-wrap .search-bat-select,\n.search-bat-wrap .search-bat-input {\n  width: 100%;\n  padding: 9px 11px;\n  border-radius: 8px;\n  border: 1.5px solid #d1d5db;\n  font-size: 13px;\n  color: #101828;\n  background: #fff;\n  outline: none;\n  font-family: Roboto, sans-serif;\n}\n.search-bat-wrap .search-bat-select:focus,\n.search-bat-wrap .search-bat-input:focus {\n  border-color: #3b6fe8;\n}\n.search-bat-wrap .search-bat-input:disabled {\n  background: #f8fafc;\n  color: #64748b;\n  cursor: not-allowed;\n}\n.serach-tittle{\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n  display: block;\n  margin-bottom: 7px;\n  font-family: 'Roboto', sans-serif;\n}\n\n/* Select2 (react-select) for Office and Team Member */\n.search-bat-wrap .search-bat-select2__control {\n  min-height: 38px !important;\n  border-radius: 8px !important;\n  border: 1.5px solid #d1d5db !important;\n  font-size: 13px !important;\n  color: #111;\n  background: #fff;\n  outline: none;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n}\n.search-bat-wrap .search-bat-select2__control--is-focused {\n  border-color: #3b6fe8 !important;\n  box-shadow: 0 0 0 1px #3b6fe8 !important;\n}\n.search-bat-wrap .search-bat-select2__control:hover {\n  border-color: #d1d5db !important;\n}\n.search-bat-wrap .search-bat-select2__control--is-disabled {\n  cursor: not-allowed !important;\n  background: #f8fafc !important;\n}\n.search-bat-wrap .search-bat-select2__control--is-disabled * {\n  cursor: not-allowed !important;\n}\n.search-bat-wrap .search-bat-select2__menu {\n  z-index: 20;\n}\n.search-bat-wrap .search-bat-select2__menu-list {\n  max-height: 240px;\n}\n.search-bat-wrap .search-bat-select2__option--is-focused {\n  background: #f4f6fb;\n}\n.search-bat-wrap .search-bat-select2__option--is-selected {\n  background: #eef3ff;\n  color: #1e3a8a;\n}\n.search-bat-wrap .search-bat-select2__input-container,\n.search-bat-wrap .search-bat-select2__single-value {\n  font-size: 13px;\n  color: #111;\n}\n\n.search-bat-wrap .search-bat-divider {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 20px 0 14px;\n}\n.search-bat-wrap .search-bat-divider-line {\n  height: 1px;\n  flex: 1;\n  background: #e5e9f2;\n}\n.search-bat-wrap .search-bat-divider-text {\n  /* font-size: 11px;\n  font-weight: 500;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  white-space: nowrap;\n  font-family: \"Roboto\", sans-serif; */\n  font-size: 11px;\n  font-weight: 500;\n  color: #9CA3AF;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  white-space: nowrap;\n  font-family: 'Roboto', sans-serif;\n}\n.search-bat-wrap .search-bat-btn-row {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 22px;\n}\n.search-bat-wrap .search-bat-btn-reset {\n  padding: 10px 18px;\n  border-radius: 8px;\n  border: 1.5px solid #d1d5db;\n  background: #fff;\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n  font-family: \"Roboto\", sans-serif;\n}\n.search-bat-wrap .search-bat-btn-go {\n  padding: 10px 22px;\n  border-radius: 8px;\n  border: none;\n  background: linear-gradient(135deg, #f0a030, #e8880a);\n  font-size: 13px;\n  font-weight: 700;\n  color: #fff;\n  cursor: pointer;\n  font-family: \"Roboto\", sans-serif;\n  box-shadow: 0 2px 12px rgba(240, 160, 48, 0.35);\n}\n.search-bat-wrap .search-bat-btn-go:disabled {\n  background: #e5e9f2;\n  color: #9ca3af;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n.search-bat-wrap .search-bat-hidden {\n  display: none !important;\n}\n\n/* --------- Exact sample selectors (Search.html) --------- */\n.divider {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 20px 0 14px;\n}\n.divider-line {\n  height: 1px;\n  flex: 1;\n  background: #E5E9F2;\n}\n.divider-text {\n  font-size: 11px;\n  font-weight: 500;\n  color: #9CA3AF;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  white-space: nowrap;\n  font-family: \"Roboto\", sans-serif;\n}\n.btn-row {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 22px;\n}\n.btn-reset {\n  padding: 10px 18px;\n  border-radius: 8px;\n  border: 1.5px solid #D1D5DB;\n  background: #fff;\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n  font-family: \"Roboto\", sans-serif;\n}\n.btn-go {\n  padding: 10px 22px;\n  border-radius: 8px;\n  border: none;\n  background: linear-gradient(135deg,#F0A030,#E8880A);\n  font-size: 13px;\n  font-weight: 700;\n  color: #fff;\n  cursor: pointer;\n  font-family: \"Roboto\", sans-serif;\n  box-shadow: 0 2px 12px rgba(240,160,48,0.35);\n}\n.btn-go:disabled {\n  background: #E5E9F2;\n  color: #9CA3AF;\n  box-shadow: none;\n  cursor: not-allowed;\n}\n.hidden {\n  display: none !important;\n}\n\n/* ---------- Mobile responsive tweaks & card-style layout ---------- */\n@media (max-width: 768px) {\n  .search-bat-wrap .search-bat-search-box {\n    height: 44px;\n  }\n\n  .search-bat-wrap .search-bat-search-input {\n    padding-top: 0;\n    padding-bottom: 0;\n    height: 100%;\n    display: flex;\n    align-items: center;\n  }\n\n  .search-bat-wrap .search-bat-clear-btn {\n    height: 100%;\n  }\n  /* .search-bat-wrap .search-bat-body {\n    padding: 16px 12px 20px;\n  } */\n\n  .search-bat-wrap .search-bat-search-box {\n    border-radius: 12px;\n  }\n\n  /* On mobile, use full width for better tap targets */\n  .signage-search-half .search-bat-search-box {\n    width: 100% !important;\n  }\n\n  .signage-search-half .search-bat-search-wrap {\n    width: 100% !important;\n  }\n\n  .signage-search-half .search-bat-dropdown {\n    right: 0 !important;\n    width: auto !important;\n  }\n\n  .search-bat-wrap .search-bat-dropdown {\n    left: -4px;\n    right: -4px;\n    max-height: 60vh;\n  }\n\n  /* Make each result more like a card on mobile */\n  .search-bat-wrap .search-bat-drop-row {\n    flex-direction: column;\n    align-items: stretch;\n    padding: 12px 14px;\n    margin: 6px 10px;\n    gap: 10px;\n    border-radius: 16px;\n    border: 1px solid #e5e9f2;\n  }\n\n  .search-bat-wrap .search-bat-drop-icon {\n    width: 72px;\n    height: 72px;\n    margin: 0 auto;\n  }\n\n  .search-bat-wrap .search-bat-drop-main {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n  }\n\n  .search-bat-wrap .search-bat-drop-text {\n    align-items: flex-start;\n  }\n\n  .search-bat-wrap .search-bat-drop-name {\n    font-size: 13px;\n  }\n\n  .search-bat-wrap .search-bat-drop-meta {\n    font-size: 11px;\n  }\n\n  .search-bat-wrap .search-bat-drop-email {\n    font-size: 11px;\n  }\n\n  /* Stack office / team member selects and contact fields */\n  .search-bat-wrap .search-bat-grid2 {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .search-bat-wrap .search-bat-brok-card {\n    padding: 14px;\n    margin-top: 16px;\n  }\n\n  .search-bat-wrap .search-bat-brok-top {\n    align-items: flex-start;\n  }\n}\n\n.search-bat-field-error {\n  margin-top: 4px;\n  font-size: 12px;\n  color: #dc3545;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
